'use strict';

import jQuery from 'jquery';
import autoComplete from 'javascript-autocomplete';

const organizationsInput = (function($) {
  /*
	 *
	 * @param term - keyword
	 * @param parent - form group which contains inputs to be populated
	 * @param replaceEl - the DOM element whose content will be replaced
	 * 		with the results from autocomplete
	 */
  function doAutocomplete(parent, replaceEl) {
    new autoComplete({
      selector: '.js-sf-place',
      source: function(term, suggest) {
        $.getJSON(
          `http://shop-dev.concordtheatricals.com/ajax/orglist?term=${term}&typeId=1`,
          function(data) {
            const choices = data;
            let suggestions = [];
            for (let i = 0; i < choices.length; i++) {
              if (choices[i].value.toLowerCase().indexOf(term) > -1)
                suggestions.push(choices[i]);
              suggest(data);
            }
          }
        );
      },
      minChars: 3,
      delay: 150,
      renderItem: function(item, search) {
        const itemName = item.label;
        const itemAddress = item.address;
        search = search.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&amp;');
        const re = new RegExp('(' + search.split(' ').join('|') + ')', 'gi');
        return `<div class="autocomplete-suggestion" data-orgname="${itemName}" data-orgaddress="${itemAddress}" data-val="${search}"><span class="name">${itemName.replace(
          re,
          '<b>$1</b>'
        )}</span> <span class="address">${itemAddress}</span></div>`;
      },
      onSelect: function(item) {
        document.querySelector('.js-sf-place').value = item.getAttribute(
          'data-orgname'
        );
        updateAddress(parent, replaceEl, item);
      },
    });
  }

  /*
	 *
	 * @param parent - form group which contains inputs to be populated
	 * @param replaceEl - the DOM element whose content will be replaced
	 * 		with the results from autocomplete
	 * @param org - org item from autocomplete input selection
	 */
  function updateAddress(parent, replaceEl, org) {
    const name = org.getAttribute('data-orgname');
    const placeAddress = org.getAttribute('data-orgaddress');
    const city = placeAddress.split(', ')[0];
    const state = placeAddress.split(', ')[1];

    // get the elements to fill, from the parent el
    const label = parent.querySelector('.radio-label');
    const cityInput = parent.querySelector('input[id^="new-city-"]');
    const stateInput = parent.querySelector('input[id^="new-state-"]');

    // replace the label with the name of the org
    replaceEl.innerHTML = placeAddress;
    label.innerHTML = name;
    if (cityInput) cityInput.value = city;
    if (stateInput) stateInput.value = state;
  }

  function autocompleteListener() {
    const inputs = document.querySelectorAll('.js-sf-place');

    [...inputs].forEach(input => {
      const parent = input.parentNode.parentNode;
      const replaceEl = document.getElementById(input.dataset.replace);

      input.addEventListener('keyup', function() {
        doAutocomplete(input.value, parent, replaceEl);
      });
    });
  }

  function init() {
    autocompleteListener();
  }

  window.addEventListener('DOMContentLoaded', init);
})(jQuery);

export default organizationsInput;



// WEBPACK FOOTER //
// ./resources/assets/js/organizations-input.js